import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ssc-base-overlay',
  templateUrl: './base-overlay.component.html',
  styleUrls: ['./base-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaseOverlayComponent {
  @Output()
  public closed = new EventEmitter();
}
